
export const USER_TYPE={
    WARE_HOUSE_OWNER:6,
    BANKER:7,
    CORPORATE:3,
    CORPORATE_USER:4,
    FARMER_USER:5,
    SUPER_ADMIN:1,
    SUB_ADMIN:2
}